import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { TestimonialRequestWhiteLabelAdminAPI } from '../../services/wladmin/testimonialRequestWhiteLabelAdminAPI';
import { TestimonialLinkSubmissionWhiteLabelAdminAPI } from '../../services/wladmin/testimonialLinkSubmissionWhiteLabelAdminAPI';
import { BrandVideoWhiteLabelAdminAPI } from '../../services/wladmin/brandVideoWhiteLabelAdminAPI';
import { BackgroundMusicAPI } from '../../services/backgroundMusicAPI';
import {VideoDetailsBase} from '../base/video';
import { FontAPI } from '../../services/fontAPI';
import { AccountWhiteLabelAdminAPI } from '../../services/wladmin/accountWhiteLabelAdminAPI';
import { EnvironmentService } from '../../services/environmentService';

@inject(AuthService, UserMessageService, Router, BackgroundMusicAPI, FontAPI, AccountWhiteLabelAdminAPI, EnvironmentService)
export class VideoDetails extends VideoDetailsBase {
    constructor(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, envService) {
        super(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, "api/wladmin", TestimonialRequestWhiteLabelAdminAPI, TestimonialLinkSubmissionWhiteLabelAdminAPI, BrandVideoWhiteLabelAdminAPI, envService, true);
        this.isWlManager = this.authService.getUser().role === 'WLMANAGER';
        this.email = null;
    }
    activate(params, route) {

        super.activate(params, route);
        if(!params.id && params.account_owner_id) {
            this.account_owner_user_id = params.account_owner_id;
        }

    }


    reset() {


        this.accountApi.getUserData(
            this.account_owner_user_id,
            this.authService.getUser().token,
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                super.reset();
            },
            this.saveLoadError.bind(this));
    }

    setData(data) {
        super.setData(data);
        this.accountApi.getUserData(
            this.account_owner_user_id,
            this.authService.getUser().token,
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                this.email = userData.user.email;
                this.user_email=userData.user.email;
                this.user_name=userData.user.first_name+' '+userData.user.last_name;
            },
            this.saveLoadError.bind(this));

        this.capture_override = data.capture_override;
    }
    openUserDetail(){
        this.router.navigate("#/wladmin/user/"+this.account_owner_user_id);
    }
    reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    recreate() {


        if (confirm("Are you sure you want to re-create this video?")) {
            if (this.validate()) {
              if (this.enableSubtitle) {
                if (this.subtitles.caption.length == 0) {
                  this.userMessageService.setUserError(
                    "user",
                    "Subtitles are empty."
                  );
                  return;
                }
                this.subtitles.styles = this.transcriptGenerator.selectedStyle
                ? this.transcriptGenerator.selectedStyle
                : this.transcriptGenerator.styles[0]; //settting default styles
    
              }

      this.saving = true;
      var data = this.getData();
      this.api.recreate(
          data,
          (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
          this.authService.getUser().token,
          this.saveLoadSuccess.bind(this),
          this.saveLoadError.bind(this));
      }
    }
  }

    uploadCaptureOverride() {
        if (this.captureOverride_files && this.captureOverride_files.length > 0) {
            this.saving = true;
            this.api.saveCaptureOverride(this.id,
                this.captureOverride_files[0],
                this.authService.getUser().token,
                () => {this.overrideCaptureChanged(true)},
                (msg) => { this.userMessageService.setUserError("user", msg)});
        }
    }

    removeCaptureOverride() {
        this.saving = true;
        this.api.removeCaptureOverride(this.id,
            this.authService.getUser().token,
            () => {this.overrideCaptureChanged(false)},
            (msg) => { this.userMessageService.setUserError("user", msg)});
    }

    overrideCaptureChanged(capture_override) {
        this.userMessageService.setUserMessage("user", "Saved!");

        this.saving = false;

        this.capture_override = capture_override;


    }
}
